import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import { convertPlatformBoundsToLatLngBounds } from "@mapmycustomers/shared/util/geo/GeoService";

import MapPersistedViewportState from "@app/types/map/MapPersistedViewportState";
import MapViewportState from "@app/types/map/MapViewportState";

const convertViewportToPersist = (viewport: MapViewportState): MapPersistedViewportState => {
  let center: LongLat | undefined = undefined;
  if (viewport.bounds) {
    const bounds = convertPlatformBoundsToLatLngBounds(viewport.bounds);
    const latLngCenter = bounds.getCenter();
    center = [latLngCenter.lng(), latLngCenter.lat()] as LongLat;
  }
  return { center, zoom: viewport.zoom };
};

export default convertViewportToPersist;
